import * as DomTypeUtils from '@packages/systems/core/utils/DomTypeUtils';
import type {Context} from '../types';

// Make sure that for static HTML embeds (which include Videos), the `v` value matches the `data.embed.meta.html` exactly
// Some legacy/old sites were persisted before DomNodeUtils.getInnerHtml() was updated to account for
// DOM mutations to embed HTML, so we have to fix them up
// TEMP: With render-atoms, we will no longer rely on `v` values for embeds or videos
export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;
  const hasDynBoundHtml = DomTypeUtils.isDynBoundHtml(data);
  const isStaticEmbed =
    !hasDynBoundHtml &&
    (DomTypeUtils.isStaticHtmlEmbed(data) || DomTypeUtils.isVideo(data));
  const metaHTML = data.embed && data.embed.meta && data.embed.meta.html;
  const embedHtml =
    isStaticEmbed && metaHTML && metaHTML.trim && metaHTML.trim();

  return {
    needed: embedHtml && jsonNode.v !== embedHtml,
    logData: {
      msg: 'static embed with mismatched v and embed.meta.html',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      jsonNode.v = embedHtml;
    },
  };
};
